module.exports = __webpack_public_path__ + "static/media/salesforce.54df8fae.svg";